import { employeeContributionPairs, isPairLocked, manualPair } from '../contributionPairs';
import { useContributionFieldValues } from './useContributionFieldValues';

/**
 * True when the amount/frequency are derived and read-only — i.e. the income pair is the active
 * (higher-priority) employee-side pair, so the manual pair is locked. In that mode the backend
 * derives the amount/frequency from the income source + percentage.
 */
export const useContributionDerivedFromIncomeSource = () =>
  isPairLocked(manualPair, employeeContributionPairs, useContributionFieldValues());
